"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".footer__btHome[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{font-size:36px;width:36px;height:36px}.footer__btAccount[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{margin-right:4px}.footer[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{padding:0 12px}mat-toolbar[_ngcontent-%COMP%]{position:fixed;bottom:0;display:flex;justify-content:space-between;z-index:9}"];
exports.styles = styles;
